module.exports = __webpack_public_path__ + "img/12.328b60e5.jpg";